import { useEffect } from "react";

import { useCartServiceApi } from "@/api/hooks/cartService.hook";
import { Config } from "@/utils/config.utils";

export enum ECornerPaymentStatus {
    Waiting = "waiting",
    Success = "success",
    Failure = "faillure"
}

const TIMEOUT = 5 * 60 * 1000;
const PAYMENT_ID_URL_PARAMETER = "pid";

export const ECornerPayment = () => {
    const [_, getTerminalStatus] = useCartServiceApi(
        {
            method: "GET"
        },
        { manual: true, useCache: false }
    );

    const poll = async (paymentId: string, timeout: number) => {
        const response = await getTerminalStatus({
            url: `/checkout/payment-status/${paymentId}`
        });

        // BE does not return a status code, only a redirect header
        // Redirection means that the payment succeeded or failed and the polling is done
        if (response.status === 303 && response.headers["x-hubo-location"]) {
            return location.assign(response.headers["x-hubo-location"]);
        } else if (Date.now() <= timeout) {
            await poll(paymentId, timeout);
        } else {
            location.assign(
                `${Config.pages["checkout-payment"]}?ci-m=PAYMENT_EXPIRED`
            );
        }
    };

    useEffect(() => {
        const paymentId = new URLSearchParams(location.search).get(
            PAYMENT_ID_URL_PARAMETER
        );

        if (!paymentId) return;

        poll(paymentId, Date.now() + TIMEOUT);
        // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    }, [poll]);

    return null;
};
